import { RootState } from '../index';
import { ILoadingScreenState } from './types';

export function loadingScreenSelector(state: RootState): ILoadingScreenState {
  return state.loading.loadingScreen;
}
